import Tour from 'reactour';
import useGuidedTour from '../../hooks/use-guided-tour';
import {
	disableBodyScroll,
	enableBodyScroll
} from 'body-scroll-lock';
import { qamStudyDetailsTourSteps } from '../../utils/qamTours';

const lsStudyDetailTourKey = 'study-detail-tour';

const StudyDetailTour = () => {
	const { active } = useGuidedTour(
		lsStudyDetailTourKey,
		'/dashboard/'
	);
	const disableScroll = (target) => {
		disableBodyScroll(target);
	};

	const enableScroll = (target) => {
		enableBodyScroll(target);
	};

	const handleTourClose = () => {
		localStorage.setItem(lsStudyDetailTourKey, true);
		window.location.reload();
	};

	if (!active) {
		return;
	}

	return (
		<Tour
			steps={qamStudyDetailsTourSteps}
			isOpen={active}
			onRequestClose={handleTourClose}
			closeWithMask={false}
			disableFocusLock={true}
			scrollSmooth={false}
			accentColor='#242a60'
			rounded={7}
			disableInteraction={true}
			onAfterOpen={disableScroll}
			onBeforeClose={enableScroll}
		/>
	);
};

export default StudyDetailTour;
